<template>
  <div class="sign-card">
    <pageHeader
      whiteIcon
      title="签到月卡"
      bgColor="transparent"
      color="#FFFFFF"
    />

    <div class="sign-container">
      <div class="sign-in-day-box">
        <span class="sign-in-number">{{ signNumber }}</span>
        <span class="sign-desc">您已连续签到天数</span>
      </div>

      <div class="sign-in-box">
        <div class="sign-tips">
          <img src="@/assets/images/species.png" alt="" />
          <span>连续签到奖励更丰厚</span>
        </div>
        <div class="sign-in-container">
          <div
            :class="['sign-in-item', signInClassFormat(item, i)]"
            v-for="(item, i) in signList"
            :key="item.dateName"
          >
            <span class="day">{{ item.dateName }}</span>
            <img :src="signInIconFormat(item, i)" alt="" />
            <span class="sign-text">{{ signInTextFormat(item, i) }}</span>
          </div>
        </div>

        <div
          :class="['sign-in-btn', isSignInToday ? 'sign-in-today' : '']"
          @click="signIn"
        >
          {{ isSignInToday ? "已签到" : "签到" }}
        </div>
      </div>

      <div class="month-card">
        <van-tabs
          v-model="active"
          line-height="5px"
          color="#FF8440"
          title-active-color="#FF8440"
          title-inactive-color="#414141"
          @click="monthCardChange"
        >
          <van-tab title="普通月卡" name="MONTH_CARD">
            <div class="card">
              <img src="@/assets/images/bg_benefit_s_com_card.png" alt="" />
            </div>
          </van-tab>
          <van-tab title="至尊月卡" name="SUPREME_MONTH_CARD">
            <div class="card">
              <img src="@/assets/images/bg_benefit_s_super_card.png" alt="" />
            </div>
          </van-tab>
        </van-tabs>

        <div
          :class="[
            'sign-in-btn',
            monthCardInfo.isGetMonthCoupon4Today ? 'is-get-month-card' : '',
          ]"
          @click="getMonthCard"
        >
          {{ monthCardInfo.showInfo }}
        </div>
        <div class="month-expires-day" v-if="monthCardInfo.buyMonthCard">
          <span>月卡剩余天数：{{ monthCardInfo.expiresDays }}</span
          ><span @click="monthCard9" v-if="monthCardInfo.canContinueBuy"
            >9折续费</span
          >
        </div>
        <div class="month-card-desc">
          <div class="month-card-desc-title">
            <img src="@/assets/images/dot-left.png" alt="" />
            <h1>月卡介绍</h1>
            <img src="@/assets/images/dot-right.png" alt="" />
          </div>
          <div class="desc-content" v-if="active == 'MONTH_CARD'">
            1、开通后，可每天领取1张满6减6券，累计30张；<br />
            2、月卡券需在此页面领取，有效期3天，供APP内充值使用；<br />
            3、月卡属虚拟产品，开通后（包括过期）不支持退款；<br />
            4、充值时，若折扣大于4.8折，无法直接使用，需转换成万能券后使用，但面额会减少为原来的80%，向下取整数；<br />
            5、充值时，若折扣等于0.1折，月卡券金额扩大为600元；<br />
            6、同一游戏账号，仅能在一个万梦账号上使用优惠券；
          </div>
          <div class="desc-content" v-else>
            1、开通后，可每6天领取1张满328减100券，累计5张（如1号开通，则1-6号内可领1张，7-12号可领1张，以此类推）；<br />
            2、月卡券需在此页面领取，有效期3天，供APP内充值使用；<br />
            3、月卡属虚拟产品，开通后（包括过期）不支持退款；<br />
            4、充值时，若折扣大于4.8折，无法直接使用，需转换成万能券后使用，但面额会减少为原来的80%，向下取整数；<br />
            5、同一游戏账号，仅能在一个万梦账号上使用优惠券；<br />
          </div>
        </div>
      </div>
    </div>

    <couponDialog
      v-if="couponDialogVisible"
      v-model="couponDialogVisible"
      :couponInfo="couponInfo"
    />

    <rechagePayWayPopup
      v-if="rechagePayWayPopupVisible"
      v-model="rechagePayWayPopupVisible"
      :payInfo="payInfo"
      @balancePayEvent="balancePayEvent"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import couponDialog from "@/components/CouponDialog";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import rechagePayWayPopup from "@/components/RechagePayWayPopup";
export default {
  components: {
    pageHeader,
    couponDialog,
    rechagePayWayPopup,
  },
  data() {
    return {
      signNumber: 0,
      active: "MONTH_CARD",
      signList: [],
      SIGN_IN_3: null,
      SIGN_IN_7: null,
      couponDialogVisible: false,
      couponAmount: null,
      couponAmountMaps: {
        3: this.SIGN_IN_3,
        7: this.SIGN_IN_7,
      },
      monthCardInfo: {},
      couponInfo: {},
      rechagePayWayPopupVisible: false,
      isSignInToday: false,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),

    signInIconFormat() {
      return function (item, index) {
        if (index == 2) {
          return require(`@/assets/images/${this.SIGN_IN_3}-box.png`);
        }
        if (index == 6) {
          return require(`@/assets/images/${this.SIGN_IN_7}-box.png`);
        }
        if (index != 2 && index != 6) {
          if (item.isSignIn == 0 && item.dateName != "今天") {
            return require("@/assets/images/sign-out-gray.png");
          } else {
            return require("@/assets/images/sign-in-white.png");
          }
        }
      };
    },
    signInTextFormat() {
      return function (item, index) {
        return item.isSignIn == 1 && item.dateName != "今天"
          ? "已签"
          : item.isSignIn == 1 && item.dateName == "今天"
          ? "今日已签"
          : item.isSignIn == 0 && item.dateName == "今天"
          ? "今日可签"
          : "未签";
      };
    },

    signInClassFormat() {
      return function (item, index) {
        let classList = [];
        if (index == 2) {
          classList.push("three-sign-item");
        }
        if (index == 6) {
          classList.push("seven-sign-item");
        }
        if (item.isSignIn == 0 && item.dateName == "今天") {
          classList.push("can-sign-in-item");
        }
        if (item.isSignIn == 1) {
          classList.push("sign-in-item-actived");
        }
        return classList.join(" ");
      };
    },
  },
  async mounted() {
    await this.signInInfoQr();
    this.monthCardInfoQr();
  },
  methods: {
    /**
     *获取签到信息
     */
    async signInInfoQr() {
      try {
        const { data } = await requestMethods(
          "/modules/sign/userSign/innerSignIn.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        const { continueDays, SIGN_IN_7, SIGN_IN_3, resultList } = data;
        this.signNumber = continueDays;
        this.SIGN_IN_3 = SIGN_IN_3;
        this.SIGN_IN_7 = SIGN_IN_7;
        this.signList = resultList || [];

        const isSign = this.signList.filter((e) => e.dateName == "今天");
        this.isSignInToday = isSign[0].isSignIn == 1;
      } catch (err) {}
    },
    /**
     * 签到
     */
    async signIn() {
      if (this.isSignInToday) {
        return;
      }
      try {
        const { data } = await requestMethods(
          "/modules/sign/userSign/userSignIn.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        await this.signInInfoQr();
        const { isGetCoupon } = data;
        if (isGetCoupon == 1) {
          this.couponInfo = {
            amount: this.couponAmountMaps[this.signNumber],
            classify: "COMMON",
            couponName: "月卡优惠券",
            enableAmount: this.couponAmountMaps[this.signNumber],
          };
          this.couponDialogVisible = true;
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },

    /**
     * 月卡类型tab切换
     */
    async monthCardChange() {
      await this.monthCardInfoQr();
    },

    // 获取月卡购买信息
    async monthCardInfoQr() {
      try {
        const { data } = await requestMethods(
          "/modules/goods/userMonthCard/monthCardInfo.htm",
          "post",
          {
            uuid: this.uuid,
            goodsType: this.active,
          }
        );
        this.monthCardInfo = { ...data };
      } catch (err) {}
    },

    /**
     * 购买或领券
     */
    getMonthCard() {
      if (this.monthCardInfo.buyMonthCard) {
        if (!this.monthCardInfo.isGetMonthCoupon4Today) {
          // 去领券
          this.getCoupon();
        }
      } else {
        this.buyMonthCard();
      }
    },

    /**
     * 9折续费
     */
    monthCard9() {
      this.payInfo = {
        uuid: this.uuid,
        goodsType: this.active,
        renew: "YES",
        apiUrl: "/modules/goods/userMonthCard/buyMonthCard.htm",
      };
      localStorage.setItem('payRouter', JSON.stringify('monthCard'))
      this.rechagePayWayPopupVisible = true;
    },

    /**
     * 开通月卡
     */
    buyMonthCard() {
      this.payInfo = {
        uuid: this.uuid,
        goodsType: this.active,
        apiUrl: "/modules/goods/userMonthCard/buyMonthCard.htm",
      };
      localStorage.setItem('payRouter', JSON.stringify('monthCard'))
      this.rechagePayWayPopupVisible = true;
    },

    /**
     * 点击领券
     */
    async getCoupon() {
      try {
        const { data } = await requestMethods(
          "/modules/coupon/userCoupon/fetchMonthCardCoupon.htm",
          "post",
          {
            uuid: this.uuid,
            goodsType: this.active,
          }
        );
        this.couponInfo = { ...data };
        this.couponDialogVisible = true;
        this.monthCardInfoQr();
      } catch (err) {}
    },

    async balancePayEvent() {
      this.rechagePayWayPopupVisible = false
      await this.signInInfoQr();
      this.monthCardInfoQr();
    },
  },
};
</script>

<style lang="scss">
.sign-card {
  background: #f8f8f8;
  padding-bottom: 50px;
  .sign-container {
    margin-top: -88px;

    .sign-in-day-box {
      background: url("~@/assets/images/sign-in.png");
      background-size: 100% 100%;
      width: 100%;
      height: 430px;

      span {
        display: block;
      }

      .sign-in-number {
        font-family: Helvetica;
        font-size: 70px;
        color: #ffffff;
        line-height: 60px;
        padding-left: 84px;
        padding-top: 181px;
      }
      .sign-desc {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #ffffff;
        line-height: 33px;
        padding-left: 84px;
        margin-top: 10px;
      }
    }

    .sign-in-box {
      width: 680px;
      height: 573px;
      background: #ffffff;
      box-shadow: 0px 2px 20px 0px rgba(206, 206, 206, 0.38);
      border-radius: 24px;
      margin: 0 auto;
      margin-top: -112px;

      .sign-tips {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 26px;
        padding-bottom: 5px;

        img {
          width: 26px;
          height: 26px;
          margin-right: 3px;
        }
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #000000;
          line-height: 26px;
        }
      }

      .sign-in-container {
        padding: 0 20px;
        display: flex;
        flex-wrap: wrap;
        .sign-in-item {
          width: 140px;
          height: 180px;
          background: #f7f5f2;
          border-radius: 16px;
          margin: 10px;
          text-align: center;

          img {
            width: 50px;
            height: 50px;
            margin: 25px 0;
          }
          span {
            display: block;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 22px;
            color: #282d42;
            line-height: 30px;
          }
          .sign-text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 22px;
            color: #9fa3a9;
            line-height: 30px;
          }
          .day {
            margin-top: 10px;
          }
        }
        .three-sign-item {
          img {
            margin: 0;
            width: 114px;
            height: 108px;
          }
          span {
            &:last-child {
              line-height: 20px;
            }
          }
        }
        .seven-sign-item {
          width: 300px;
          img {
            margin: 0;
            width: 114px;
            height: 108px;
          }
          span {
            &:last-child {
              line-height: 20px;
            }
          }
        }

        .can-sign-in-item {
          background: #ff8440;

          span {
            color: #ffffff;
          }
          .sign-text {
            color: #ffffff;
          }
        }
        .sign-in-item-actived {
          background: #ff8440;
          opacity: 0.5;

          span {
            color: #ffffff;
          }
          .sign-text {
            color: #ffffff;
          }
        }
      }
      .sign-in-btn {
        width: 420px;
        height: 80px;
        margin: 0 auto;
        margin-top: 10px;
        background: url("~@/assets/images/sign-btn-bg.png");
        background-size: 100% 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 80px;
      }
      .sign-in-today {
        opacity: 0.5;
      }
    }
    .month-card {
      width: 680px;
      height: 1000px;
      background: #ffffff;
      box-shadow: 0px 2px 20px 0px rgba(206, 206, 206, 0.38);
      border-radius: 24px;
      margin: 0 auto;
      margin-top: 30px;

      .card {
        width: 640px;
        height: 350px;
        margin: 0 auto;
        margin-top: 20px;
        img {
          width: 640px;
          height: 350px;
        }
      }
      .sign-in-btn {
        width: 420px;
        height: 80px;
        margin: 0 auto;
        margin-top: 30px;
        background: url("~@/assets/images/sign-btn-bg.png");
        background-size: 100% 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 80px;
      }
      .is-get-month-card {
        opacity: 0.5;
      }
      .month-expires-day {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 12px;

        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #a2a2a2;

          &:last-child {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 22px;
            color: #ff7a3e;
            text-align: left;
            font-style: normal;
            text-decoration-line: underline;
            margin-left: 50px;
          }
        }
      }

      .month-card-desc {
        margin-top: 58px;

        .month-card-desc-title {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 57px;
            height: 20px;
          }
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 30px;
            color: #212121;
            line-height: 42px;
            margin: 0 12px;
          }
        }
        .desc-content {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #414141;
          line-height: 40px;
          padding: 20px 25px;
        }
      }
    }
  }
  .van-tab {
    font-size: 28px;
  }
  .van-tab--active {
    font-size: 32px;
    font-weight: 600;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/signCard/index.vue